<template>
  <div class="name">
    <p v-if="params.data.type === 'Folder'" @click="goInFolder">
      {{ params.value }}
    </p>
    <a v-else :href="params.data.file_url" target="_blank">
      <p class="text-white">{{ params.value }}</p>
    </a>
    <!-- <p v-else @click="myTest(params.data.file_url, params.value)">
      {{ params.value }}
    </p> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  mounted() {
    console.log("params", this.params);
  },
  methods: {
    goInFolder() {
      if (this.$route.path.includes("userfile")) {
        this.$store.dispatch("create/setFolderLevelName", {
          name: `/ ${this.params.value}`,
          folderId: this.params.data.folder_id,
        });
        this.$router.push(`/userfile/${this.params.data.folder_id}`);
      } else {
        this.$store.dispatch("create/setFolderLevelName", {
          name: `/ ${this.params.value}`,
          folderId: this.params.data.folder_id,
        });
        this.$router.push(`/foldermanagement/${this.params.data.folder_id}`);
      }
    },
    downloadFile(path) {
      var save = document.createElement("a");
      save.href = path;
      save.download = "Your file name here";
      save.target = "_blank";
      document.body.appendChild(save);
      // save.click();
      save.download();
      document.body.removeChild(save);
    },
  },
};
</script>

<style scoped>
.name {
  cursor: pointer;
  width: 1000px;
}
</style>
